import { Component, type ErrorInfo, type ReactNode } from "react";
import { track, flush } from "@/lib/telemetry";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
}

export default class TelemetryErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    track("error", "react-error-boundary", {
      meta: {
        message: String(error?.message ?? error).slice(0, 300),
        stack: error?.stack?.slice(0, 1200),
        component_stack: info.componentStack?.slice(0, 1200),
      },
    });
    flush(true);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div className="p-6 text-sm text-muted-foreground">
            Une erreur est survenue. Recharge la page pour continuer.
          </div>
        )
      );
    }
    return this.props.children;
  }
}
